import axios from 'axios';
import {
	ACCESS_TOKEN,
	API_URL,
} from './Variables';
import VueCookies from 'vue-cookies';
let tenantId = VueCookies.get('lmsTenantId')
let client = (baseUrl = null, additionalHeaders = {}, useTenant = true) => {
    let accessToken = VueCookies.get('lmsAccessToken');
    if (!accessToken) {
        accessToken = localStorage.getItem('lmsAccessToken');
    }

	let defaultHeaders = {
		'X-Requested-With': 'XMLHttpRequest',
		'Accept': 'application/json',
		'Authorization': 'Bearer ' + accessToken
	};

	if (tenantId && useTenant) {
        defaultHeaders['X-Tenant'] = tenantId;
    }

	let axiosOptions = {
		baseURL: baseUrl,
		headers: {
			...defaultHeaders,
			...additionalHeaders
		},
	};

	return axios.create(axiosOptions);
};

class ApiClientFactory {
	constructor(baseUrl = null, useTenant=true) {
		if (baseUrl == null) {
			baseUrl = API_URL;
		}

		this.baseUrl = baseUrl;
		this.useTenant = useTenant;
	}

	get(url, requestData = {}, headers = {}) {
		return client(this.baseUrl, headers, this.useTenant).get(url, requestData);
	}

	post(url, requestData = {}, headers = {}) {
		return client(this.baseUrl, headers, this.useTenant).post(url, requestData);
	}

	put(url, requestData = {}, headers = {}) {
		return client(this.baseUrl, headers, this.useTenant).put(url, requestData);
	}

	delete(url, requestData = {}, headers = {}) {
		return client(this.baseUrl, headers, this.useTenant).delete(url, requestData);
	}
}

export {
	ApiClientFactory
};
